<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li><a href="/#/bridge" v-on:click="sendMsg">桥梁振动监测</a></li>
            <li class="active">索力测试</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">BY-S07型低频振动传感器</h1>
            <hr>
            <img src="../../assets/product/vibrate/BY_S07/BY-S07.png" alt="">
            <p class="titleP">概述</p>
            <p>BY-S07型低频振动传感器可用于如下情况的低频振动监测：</p>
            <p>1) 地面和各种结构物的脉动测量及振动监测。</p>
            <p>2) 一般工程结构如桥梁、楼房、码头、大坝、海洋平台等的脉动测量和各种振动试验中的振动测量及监测。</p>
            <p>3) 诸如水轮发电机组等大型旋转设备的振动测量。</p>
            <p>4) 隔振平台等的微弱振动测量。</p>
            <p>5) 诸如悬索桥等高柔结构的超低频大幅值测量。</p>
            <p>6) 其他低频超低频振动测量。</p>
            <p class="titleP">技术指标</p>
            <img src="../../assets/product/vibrate/BY_S07/index1.png" alt="">
            <img src="../../assets/product/vibrate/BY_S07/index2.png" alt="">
            <img src="../../assets/product/vibrate/BY_S07/index3.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/productDetails.vue